import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandPlan } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = BrandPlan

export const fetchBrandPlan = async ({
  id,
  workspaceId,
  signal,
}: {
  id: number
  workspaceId: number
  signal?: AbortSignal
}) => {
  const res = await sendToApi<{ brand_plan: BrandPlan }>(`/w/${workspaceId}/brand_plans/${id}`, { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.brand_plan
}

export const useBrandPlan = (id: number, options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(
    ['workspaces', workspaceId, 'brandPlans', 'detail', id],
    () => fetchBrandPlan({ id, workspaceId }),
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
